import dynamicAPI from './dynamicAPI'
import { useMutation, useQueryClient } from 'react-query'

const url = '/api/auth/estadistics'
const queryKey = 'estadistics'

export default function useEstadisticHook() {

  const queryClient = useQueryClient()
  
  const postEstadistics = useMutation(
    async (obj) => await dynamicAPI('post', `${url}` , obj),
    {
      retry: 0,
      onSuccess: () => queryClient.invalidateQueries([queryKey]),
    }
  )

  return { postEstadistics }
}
